module.exports = __webpack_public_path__ + "img/dod_day12_image_02.deeac730.jpg";